module.exports = __webpack_public_path__ + "img/wall-remain-07.3c27743f.png";